import messages from './adminAnalytics.json' with { type: 'json' };

export const adminAnalyticsFi: Readonly<typeof messages> = messages;
